module.exports = __webpack_public_path__ + "img/avatars-group.f83fa9f9.png";